<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item">
            <router-link
                v-bind:to="{ name: 'Tasks', query: { taskmaster_id: $store.state.users.current.id } }"
                v-bind:class="(($route.name == 'Tasks') ? settingsLinkActiveClass : '' )"
            >
                <span>Мои задачи (создатель)</span>
            </router-link>
        </li>
        <li class="main-menu__item">
            <router-link
                v-bind:to="{ name: 'Tasks', query: { responsible_id: $store.state.users.current.id, responsible: $store.state.users.current.login } }"
                v-bind:class="(($route.name == 'Tasks') ? settingsLinkActiveClass : '' )"
            >
                <span>Мои задачи (исполнитель)</span>
            </router-link>
        </li>        
    </ul>
</template>
<script>
    export default {
        name: 'tasks-favorites-menu',
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FavoritesMenu.vue?b33caa72